import { Component, Input } from '@angular/core';
import { Segment } from 'src/main/webapp/assets/models/iter.model';

/**
 * Componente per specificare un segment
 */
@Component({
  selector: 'app-flight-segment-detail',
  styleUrls: ['./flight-segment-detail.component.scss'],
  templateUrl: './flight-segment-detail.component.html'
})
export class FlightSegmentDetailComponent {

  @Input() public segment!: Segment;
  @Input() public showLogo = true;
  @Input() public type: 'departure' | 'arrival';

  constructor() {
    this.type = 'departure';
  }

  public isArrival(): boolean{
    return this.type === 'arrival';
  }

  public isDeparture(): boolean{
    return this.type === 'departure';
  }

}
